import React, { useRef, useEffect } from 'react';
import useMount from 'ggApp/shared/hooks/useMount';
import useUnmount from 'ggApp/shared/hooks/useUnmount';

import anime from 'animejs';
import cn from 'classnames';
import { withTheme } from 'styled-components';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import Icon from './Icon';
import { Wrap, Label } from './styled';

const Button = ({
    theme,
    menuIsOpen = false,
    isDesktopUser = false,
    showMenu,
    toggleMenu,
    closeMenu,
    className,
    gtmClassname,
}) => {
    const iconRef = useRef(null);

    const animateIcon = (variableSettings) =>
        anime({
            targets: iconRef?.current?.querySelectorAll('path.ball'),
            duration: 500,
            delay: (target, index) => index * 20,
            easing: [0, 1, 0.32, 1],
            ...variableSettings,
        });

    const buttonAnimation = () => {
        animateIcon({
            loop: true,
            scale: ['1', '1.25', '1'],
            delay: (target, index) => index * 20 + 4000,
        });
    };

    useMount(() => {
        window.addEventListener('load', buttonAnimation);
    });

    useUnmount(() => window.removeEventListener('load', buttonAnimation));

    useEffect(() => {
        if (!menuIsOpen) {
            animateIcon({
                scale: ['1.25', '1'],
            });
        }

        return () => anime.remove(iconRef?.current);
    }, [menuIsOpen]);

    const handleMouseLeave = () => {
        if (!isDesktopUser) return;

        if (!menuIsOpen) {
            animateIcon({
                scale: ['1.25', '1'],
            });
        }

        closeMenu();
    };

    const handleMouseEnter = () => {
        if (!isDesktopUser) return;

        anime.remove(iconRef?.current?.querySelectorAll('path.ball'));

        animateIcon({
            scale: ['1', '1.25'],
            loop: false,
        });

        showMenu();
    };

    const handleClick = () => {
        if (isDesktopUser) return;

        anime.remove(iconRef?.current?.querySelectorAll('path.ball'));

        toggleMenu();
    };

    return (
        <Wrap
            className={cn(className, gtmClassname)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
        >
            <Icon innerRef={iconRef} fill={theme.colors.Foreground} />

            {isDesktopUser && (
                <Label>
                    <Translator tk="CATEGORIES_BUTTON" />
                </Label>
            )}
        </Wrap>
    );
};

export default withTheme(Button);
